// Mock data for Domino Arena clone

export const navLinks = [
  { label: 'HOME', href: '#home', active: true },
  { label: 'GAMES', href: '#games' },
  { label: 'PRESALE', href: '#presale', badge: 'HOT' },
  { label: 'TOKENOMICS', href: '#tokenomics' },
  { label: 'ROADMAP', href: '#roadmap' },
  { label: 'WHITEPAPER', href: '#whitepaper' },
  { label: 'FAQ', href: '#faq' },
];

export const presaleData = {
  raised: 268540,
  goal: 700000,
  percent: 38.36,
  currentPhase: 2,
  phases: [
    { id: 1, label: 'PHASE 1', price: '$0.0010', status: 'COMPLETED' },
    { id: 2, label: 'PHASE 2', price: '$0.0015', status: 'LIVE' },
    { id: 3, label: 'PHASE 3', price: '$0.0020', status: 'UPCOMING' },
    { id: 4, label: 'PHASE 4', price: '$0.0025', status: 'UPCOMING' },
    { id: 5, label: 'LISTING PRICE', price: '$0.0030 - $0.0040', status: 'COMING SOON' },
  ],
  paymentMethods: [
    { name: 'USDC', chain: 'Solana', color: '#2775ca' },
    { name: 'USDC', chain: 'Polygon', color: '#8247e5' },
    { name: 'USDT', chain: 'TRC20', color: '#26a17b' },
    { name: 'USDT', chain: 'BEP20', color: '#f3ba2f' },
  ],
  presetAmounts: [20, 50, 100, 200],
  tokenPrice: 0.0015,
};

export const games = [
  { id: 1, name: 'DOMINO', status: 'PLAY NOW', image: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/v9vlr0z1_Screenshot_20260609_054144_ChatGPT.jpg' },
  { id: 2, name: 'LUDO', status: 'PLAY NOW', image: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/m8gfyrwo_file_00000000156471f68c1903ad18e5b9a9.png' },
  { id: 3, name: 'TIC-TAC-TOE', status: 'PLAY NOW', image: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/p82cho8p_file_00000000976c722f8490f568e9693307.png' },
  { id: 4, name: 'WAR TAP', status: 'COMING SOON', image: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/sr68z3z0_file_00000000940071f5b488b3174e47294b.png' },
  { id: 5, name: 'ROULETTE ORACLE', status: 'COMING SOON', image: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/f204zjkt_file_00000000949c71f5a696e33e31fda8b5.png' },
  { id: 6, name: 'CHESS', status: 'COMING SOON', image: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/8bunqdc1_file_000000005208720ca6a0afdd264a2aac.png' },
];

export const cubeImage = 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/8ufbv01x_file_000000001160722f922a5b6f925650e5.png';

export const whyPoints = [
  'Plateforme de jeux construite sur Solana',
  'Play to Earn – Gagnez de vrais récompenses',
  'Tournois quotidiens, classements & événements',
  'Récompenses réelles avec les tokens DOMIA',
  'Multi-jeux en 1 seule plateforme',
  'Sécurisé, transparent et 100% audité',
];

export const presaleDetails = [
  { label: 'Total Supply', value: '1,000,000,000 DOMIA' },
  { label: 'Soft Cap', value: '$100,000' },
  { label: 'Hard Cap', value: '$700,000' },
  { label: 'Total Phases', value: '4 Phases' },
  { label: 'Listing Price', value: '$0.0030 - $0.0040' },
  { label: 'Blockchain', value: 'Solana Ecosystem' },
];

export const partners = [
  { name: 'SOLANA', logo: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/ujsezg77_solana-3d-icon-png-download-8263859.png' },
  { name: 'CoinMarketCap', logo: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/jmo7390e_0x0.png' },
  { name: 'RAYDIUM', logo: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/o698hr7w_raydium-ray-logo.png' },
  { name: 'STREAMFLOW', logo: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/o1g0p7w6_34687.png' },
  { name: 'DEXSCREENER', logo: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/qlnotd3r_HIMACZhOn7YJ71dTu-actor-eoF4jxJZItdkP33r9-vZJCW562vk-dexpng.webp' },
  { name: 'COINGECKO', logo: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/wtcpxypr_CoinGecko_logo%20%281%29.png' },
];

export const sponsors = [
  { name: 'MAGIC EDEN', status: 'SOON' },
  { name: 'À VENIR', status: 'pending' },
  { name: 'À VENIR', status: 'pending' },
  { name: 'À VENIR', status: 'pending' },
];

export const community = [
  { name: 'X (Twitter)', action: 'Follow us', icon: 'twitter', url: 'https://x.com/DominoArena_DOA' },
  { name: 'Telegram', action: 'Join Channel', icon: 'telegram', url: 'https://t.me/DominoArena_DAO' },
  { name: 'YouTube', action: 'Subscribe', icon: 'youtube', url: 'https://youtube.com/@dominoarenaofficial' },
];

export const user = {
  name: 'CryptoKing',
  email: 'cryptoking@dominoarena.io',
  balance: '15,450 DOMIA',
  notifications: 3,
};

export const heroImage = 'https://customer-assets.emergentagent.com/job_c991cb56-ced2-4908-9587-c2da7f8ab08d/artifacts/kk74ezju_file_00000000a0dc720c8004b6a0a7637d3b.png';
export const lionLogo = 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/d0o55k0t_file_Domino%20Arena%20%282%29.png';

// Stablecoin icons (used in deposit / withdraw currency selectors)
export const USDC_ICON = 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/gl1ibi7k_USDC_Logo.png';
export const USDT_ICON = 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/iy8lur0k_USDT-TRC20.png';
export const whitepaperUrl = 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/1omc6xxq_Domino%20Arena%20Whitepaper_Vr%20English.pdf';
